import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import invoiceStyles from "@/styles/AccountInvoice.module.scss";
import config from "@/lib/config";
import { useAuthUserQuery } from "@/hooks";
import dayjs from "dayjs";
import { isNumber } from "lodash";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function numberWithCommas(x) {
  if (!isNumber(x)) return x;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
const InvoiceModal = props => {
  var _data$user, _data$user2;
  const {
    data
  } = useAuthUserQuery({
    variables: {},
    fetchPolicy: "cache-first"
  });
  const serviceName = config.serviceName.vod;
  const paymentDateFormatted = dayjs(props.paymentDate).format("YYYY/MM/DD") || "";
  const transactionStartAt = dayjs(props.transactionStartAt).format("YYYY/MM/DD") || "";
  const taxRate = 110;
  const taxPrice = Math.trunc(props.price - props.price * 100 / taxRate);
  const productPriceWithTax = Math.max(Math.trunc(props.productPrice * taxRate / 100), props.price);
  const discountPrice = props.discountName !== "-" ? productPriceWithTax - props.price : "-";
  return /*#__PURE__*/_jsx("div", {
    className: modalStyles.container,
    children: /*#__PURE__*/_jsxs("div", {
      className: invoiceStyles.invoiceList,
      children: [/*#__PURE__*/_jsxs("p", {
        children: [data === null || data === void 0 || (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.lastName, "\u3000", data === null || data === void 0 || (_data$user2 = data.user) === null || _data$user2 === void 0 ? void 0 : _data$user2.firstName, "\u3000\u69D8"]
      }), /*#__PURE__*/_jsx("p", {
        children: "\u4EE5\u4E0B\u306E\u901A\u308A\u9069\u683C\u8ACB\u6C42\u66F8\u3092\u767A\u884C\u3044\u305F\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/_jsxs("div", {
        className: invoiceStyles.nameBlock,
        children: [/*#__PURE__*/_jsxs("h3", {
          children: [serviceName, "\u3054\u5229\u7528\u660E\u7D30"]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.corporate,
          children: [/*#__PURE__*/_jsx("p", {
            children: "\u30B9\u30AB\u30D1\u30FCJSAT\u682A\u5F0F\u4F1A\u793E"
          }), /*#__PURE__*/_jsx("p", {
            children: "\u767B\u9332\u756A\u53F7\uFF1AT7010401072259"
          }), /*#__PURE__*/_jsx("p", {
            children: "\u6771\u4EAC\u90FD\u6E2F\u533A\u8D64\u57421-8-1"
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: invoiceStyles.table,
        children: [/*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.detail,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u5546\u54C1\u540D"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: props.name
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.date,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u6C7A\u6E08\u65E5"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: paymentDateFormatted
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.date,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u53D6\u5F15\u5E74\u6708\u65E5"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: transactionStartAt
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.price,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsxs("div", {
              className: invoiceStyles.content,
              children: ["\u304A\u652F\u6255\u91D1\u984D", /*#__PURE__*/_jsx("br", {}), "\uFF08\u7A0E\u738710%\u5BFE\u8C61\uFF09"]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsxs("div", {
              className: invoiceStyles.content,
              children: [numberWithCommas(props.price), props.price !== "-" && "円"]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.tax,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u5185\u6D88\u8CBB\u7A0E"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsxs("div", {
              className: invoiceStyles.content,
              children: [numberWithCommas(taxPrice), taxPrice !== "-" && "円"]
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: invoiceStyles.tableSecond,
        children: [/*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.price,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u5546\u54C1\u4FA1\u683C\uFF08\u7A0E\u8FBC\uFF09"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsxs("div", {
              className: invoiceStyles.content,
              children: [numberWithCommas(productPriceWithTax), productPriceWithTax !== "-" && "円"]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.name,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u5272\u5F15\u540D\u79F0"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: props.discountName
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: invoiceStyles.price,
          children: [/*#__PURE__*/_jsx("div", {
            className: invoiceStyles.header,
            children: /*#__PURE__*/_jsx("div", {
              className: invoiceStyles.content,
              children: "\u5272\u5F15\u91D1\u984D\uFF08\u7A0E\u8FBC\uFF09"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: invoiceStyles.body,
            children: /*#__PURE__*/_jsxs("div", {
              className: invoiceStyles.content,
              children: [numberWithCommas(discountPrice), discountPrice !== "-" && "円"]
            })
          })]
        })]
      })]
    })
  });
};
export default InvoiceModal;